module.exports = __webpack_public_path__ + "img/Module-Progress.f215c3f8.gif";